import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Group 38",
  "use": "icon-Group 38-usage",
  "viewBox": "0 0 30 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 80\" id=\"icon-Group 38\">\n  <g id=\"icon-Group 38_Group_38\" data-name=\"Group 38\" transform=\"translate(-160 -2162)\" opacity=\"0.5\">\n    <g id=\"icon-Group 38_Group_29\" data-name=\"Group 29\">\n      <rect id=\"icon-Group 38_Rectangle_38\" data-name=\"Rectangle 38\" width=\"30\" height=\"80\" transform=\"translate(160 2162)\" fill=\"#630106\" />\n      <path id=\"icon-Group 38_Path_2480\" data-name=\"Path 2480\" d=\"M292.03,2184.685l-3.984,3.984,3.984,3.984\" transform=\"translate(-114.546 13.815)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Group 38.svg
// module id = CZPK
// module chunks = 3